<script setup lang="ts">
    import { ArrowLeft } from 'lucide-vue-next';
    import { useRouter } from 'vue-router';
    import BaseButton from './BaseButton.vue';

    interface Props {
        label: string;
        to?: string;
        onClick?: () => void;
    }

    const props = defineProps<Props>();
    const router = useRouter();

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        } else if (props.to) {
            router.push(props.to);
        } else {
            router.back();
        }
    };
</script>

<template>
    <div class="flex justify-start">
        <base-button
            @click="handleClick"
            fill="clear"
            color="dark"
            expand="block"
            size="small"
            class="flex justify-start gap-2 whitespace-nowrap text-black transition-colors hover:text-gray-700"
        >
            <ArrowLeft class="mr-3 h-5 w-5" />
            <span class="text-base font-bold">{{ label }}</span>
        </base-button>
    </div>
</template>
